export class Coords {
    public lat: number;
    public lng: number;

    constructor();
    constructor(lat: number, long: number);
    constructor(lat?: number, long?: number) {
        if (lat) {
            this.lat = lat;
            this.lng = long;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/coords.ts